const URL = {
  COLLECTION_LIST: 'collection/filter',
  COLLECTION_LIST_LOOKUP: 'collection/lookup/public',
  COLLECTION_UPDATE: 'collection/update',
  COLLECTION_DELETE: 'collection/delete',
  COLLECTION_GET: 'collection/{id}',
  COLLECTION_CREATE: 'CourseCollection/Create',
  COLLECTION_COURSE_LIST: 'collection/{collectionId}/courses',
  COLLECTION_MEMBERS_LIST: 'collection/{id}/members/filter',
  COLLECTION_INVITE_MEMBER: 'collection/{id}/collaborators/invite',
  COLLECTION_COLLABORATORS_LIST: 'collection/{id}/collaborators/filter',
  COLLECTION_UPDATE_COLLABORATOR: 'collection/{id}/collaborators/{userId}',
  COLLECTION_PRICE: 'collection/{id}/price',
  COLLECTION_DELETE_COLLABORATOR: 'collection/{id}/collaborators/{userId}',
  COLLECTION_SHARE_LIST: 'collection/{id}/share/filter',
  COLLECTION_FILTER_COLLABORATIONS: 'collection/filter-collaborations',
  COLLECTION_ACCEPT_INVITATION_COLLABORATION:
    'collection/collaborators/accept-invitation',
  COLLECTION_DELETE_INVITATION:
    'collection/{id}/collaborators/invitations/{email}',
  COLLECTION_SHOWCASE: 'collection/showcase',
  PORTAL_RESOLVE: 'portal/resolve',
  SHOP_LANDING_PAGE: 'ShopLandingPage',
  SHOP_LANDING_PAGE_PAGES: 'ShopLandingPage/pages',
  SHOP_LANDING_PAGE_PAGE: 'ShopLandingPage/pages/{id}',
  SHOP_LANDING_PAGE_SLUG_CHECK: 'ShopLandingPage/pages/slug-check',
  SHOP_LANDING_PAGE_PAGE_CONTENT: 'ShopLandingPage/pages/{id}/landing-page',
  COLLECTION_BADGES: 'collection/{id}/badges',
  COLLECTION_BADGE_REWARD: 'collection/{id}/badge-reward',
  COLLECTION_SET_TAGS: 'collection/{id}/tags',
}

export default URL
